/* unplugin-vue-components disabled */
const __default__ = {
  mixins: [ModelValue(String)],
  props: {
    label: {type: String, default: ''},
    type: {type: String, default: 'text'},
    icon: {type: String, default: ''},
    icon_color: {type: String, default: 'var(--gray-500)'},
    iconWidth: {type: String, default: '1.6rem'},
    iconHeight: {type: String, default: '1.6rem'},
    rightIcon: {type: String, default: ''},
    rightIconColor: {type: String, default: 'var(--gray-400)'},
    error_message: {type: String, default: ''},
    // Return true for a valid value, or an error message (or false) for an invalid one.
    validator: {type: Function, default: undefined},
    tooltip: {type: String, required: false, default: ''},
    button: {type: String, required: false, default: ''},
    buttonColor: {type: String, default: 'var(--gray-600)'},
    buttonDisabled: {type: Boolean, default: false},
    spellcheck: {type: Boolean, required: false, default: true},
    required: {type: Boolean, required: false, default: false},
    minlength: {type: Number, required: false, default: undefined},
    maxlength: {type: Number, required: false, default: undefined},
    description: {type: String, required: false, default: ''},
    placeholder: {type: String, required: false, default: ''},
    focused: {type: Boolean, default: false},
    postFlush: {type: Boolean, default: false},
    loading: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    footer: {type: Boolean, default: true},
    readonly: {type: Boolean, default: false},
    step: {type: Number, default: 1},
    regexp: {type: String, default: undefined},
    min: {type: Number, default: undefined},
    max: {type: Number, default: undefined}
  },
  emits: [
    'button', 'blur', 'right-icon', 'update:valid'
  ],
  data() {
    return {
      valid: true,
      spinner_size: 0
    }
  },
  computed: {
    has_validation() {
      return this.required || this.minlength > 0 || !!this.validator
    },
    pattern(){
      if (this.regexp) return this.regexp
      switch (this.type) {
        case 'command':
          return '/.*'
        case 'identifier':
          return '[a-z0-9_]+'
        case 'url':
          return '^(www\\.)?[a-zA-Z0-9\\-\\.]+\\.[a-zA-Z]{2,}(\\/\\S*)?$'
        case 'email':
          return '[^@]+@[^@]+\\.[a-zA-Z]{2,6}'
        case 'domain':
          return '^[a-zA-Z0-9\\-]+\\.[a-zA-Z]{2,}$'
        case 'linkedin':
          return '^[a-zA-Z0-9\'\\-%.]{1,128}$'
        default:
          return null
      }
    },
    c_value: {
      get() {
        if (this.type === 'url') {
          return this.value?.replace('https://', '').replace('http://', '')
        }
        return this.value
      },
      set(val) {
        if (val == '') {
          this.value = null
        }
        else if (this.type === 'url' && !(val.startsWith('https://') || val.startsWith('http://'))) {
          this.value = `https://${val}`
        }
        else if (this.type === 'linkedin') {
          const match = val.match(/linkedin\.com\/(?:in|company|school)\/([a-zA-Z0-9'%.-]+)/i)
          const replaced = match
            ? match[1].replace(/\/$/, '')
            : val
          this.$refs.input.value = replaced
          this.value = replaced
        }
        else {
          this.value = val
        }
      }
    },
    error_text () {
      if (this.valid) return undefined
      if (this.error_message) return this.error_message

      if (this.validator) {
        const vres = this.validator(this.value)
        if (typeof vres === 'string') {
          return vres
        }
      }

      const validity = this.$refs.input.validity
      switch (this.type) {
        case 'url':
          return 'Provide a valid URL'
        case 'email':
          return 'Provide a valid email'
        case 'command':
          if (validity.patternMismatch) return 'Command must start with /'
          break
        case 'identifier':
          if (validity.patternMismatch) return 'Use only lowercase letters, numbers, and underscores'
          break
      }

      if (validity.tooShort) return `Should be at least ${this.minlength} characters long`
      if (validity.tooLong) return `Should be not more than ${this.maxlength} characters long`
      if (validity.valueMissing) return '\n'

      return 'Invalid value provided'
    },
    c_icon() {
      if (this.icon) return this.icon
      if (this.type === 'email') return 'email'
      return ''
    },
    c_spellcheck() {
      if (this.type === 'email' || this.type === 'url') return true
      return this.spellcheck
    },
    c_maxlength() {
      if (this.maxlength) return this.maxlength
      if (this.type === 'url') return 2000
      return undefined
    }
  },
  watch: {
    c_value: function () {
      if (this.postFlush) {
        this.$nextTick(() => this.checkValidity())
        return
      }
      this.checkValidity()
    }
  },
  mounted() {
    this.setOffsets()
    this.checkValidity()
    this.spinner_size = this.$refs.input.getBoundingClientRect().height + 'px'

    if (this.focused) {
      this.focus()
    }
  },
  methods: {
    isFocused(){
      return document.activeElement === this.$refs.input
    },
    focus(){
      this.$refs.input.focus()
    },
    blur(){
      this.$refs.input.blur()
    },
    setOffsets(){
      const left_width = this.$refs.label?.getBoundingClientRect().width
      if (left_width) {
        this.$refs.input.style.paddingLeft = `calc(${left_width}px + var(--input-horizontal-padding) * 2)`
      }
      const right_width = this.$refs.right?.getBoundingClientRect().width
      if (right_width) {
        this.$refs.input.style.paddingRight = `calc(${right_width}px)`
      }
    },
    checkValidity() {
      this.valid = !this.valid // this is to force dependent error_text recalc

      if (!this.value) {
        this.valid = !this.required
        return
      }

      this.valid = !!this.$refs.input?.checkValidity() &&
                   (this.validator ? this.validator(this.value) === true : true)
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "77a946ca-spinner_size": (_ctx.spinner_size)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__